import { TApiResCities } from '@core/models';
import { createRehydrateReducer } from '@core/utils/rehydrate-reducer';
import { on } from '@ngrx/store';

import { setCities } from '../actions/cities.actions';

export const citiesInitialState: TApiResCities = [];

export const citiesReducer = createRehydrateReducer(
  { key: 'citiesReducer' },
  citiesInitialState,
  on(setCities, (state, { value }): TApiResCities => [...value])
);
